import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const ConsultantProfile = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [expandedSections, setExpandedSections] = useState({
    knowledge: false,
    training: false,
    experience: false,
    clients: false,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const knowledgeAreas = [
    "Central Excise & Service Tax",
    "Customs Ports, Airports, Warehousing Stations etc.",
    "Prohibitions on importation and exportation of goods",
    "Detection of illegally imported goods and prevention of the disposal thereof",
    "Prevention or Detection of Illegal Export of Goods",
    "Levy of, and Exemption from, Customs Duties",
    "Provisions relating to conveyances carrying imported or exported goods",
    "Bond & Letter of Undertaking",
    "Registration of AD Code for Drawback and Foreign Exchange purposes",
    "Electronic Sealing and Self Sealing of Containers",
    "Clearance of imported goods and export goods",
    "Payments through electronic cash ledger",
    "Various provisions of Warehousing & Manufacture and Other Operations Warehouse Regulations",
    "Provisions regarding baggage, goods imported or exported by post",
    "Provisions relating to coastal goods and vessels carrying coastal goods",
    "Searches, seizure and arrest",
    "Confiscation of goods and conveyances and imposition of penalties",
    "Rummaging and Preventive Work",
    "Import and Export through Air Cargo and Transhipment of Cargo",
    "Drawback, All Industry Rates and Brand Rates & Return of Drawback",
    "Realisation and Repatriation of Export Sale Proceeds and e-Banking Realisation Certificates",
    "I G S T Refund under Rule 96A",
    "Rectification of various Errors in IGST Claims",
    "Knowledge in Rebate of State Levies for Textiles and Made-Ups",
    "Provisions relating to Export Oriented Undertakings",
    "Special Provisions relating to Special Economic Zone",
    "Customs Audit - Post Clearance Audit, On-Site Post Clearance Audit, Thematic Audit (TOT)",
    "Electronic Data Interchange in Customs (ICES 1.5)",
    "Recovery and Write Off of Customs Duties",
    "GST Registration",
    "Composition Scheme under GST",
    "Quality Control Orders-Bureau of Indian Standards",
    "Classification of goods and services in GST",
    "Input Tax Credit and Job Work in GST",
    "Reverse Charge Mechanism in GST",
    "Returns in GST, Paid by Exporters on Inward Supplies and Outward Supplies",
    "Exports under GST (Zero Rated Supplies)/ Drawback Incentives",
    "Deemed Exports Benefits and Procedures in GST",
    "GST and FTP – Advance Authorisation, EPCG (MEIS & RoSL)/RoDTEP & RoSCTL",
    "Customs Audit (OSPCA) On Site Post Clearance Audit",
    "Ease of Doing Business",
    "E-Waste Rules",
    "Hazardous Substances",
    "Ozone Depleting Substances",
  ];

  const clients = [
    {
      name: "M/s. CIM Technologies",
      address: ["Muthalipalayam, Tamilnadu", "Coimbatore - 641 407."],
      location: "Coimbatore, Tamilnadu",
    },
    {
      name: "M/s. Divine Atmos Pvt. Ltd.",
      address: [
        "No.136-A, MS Complex Compound,",
        "Thondamuthur Main Road,",
        "Opp. Presanth Textile Mill, Sundapalayam,",
        "Coimbatore - 641 007.",
      ],
      location: "Coimbatore, Tamilnadu",
    },
    {
      name: "M/s. Elgi Rubber India Ltd.",
      address: ["Coimbatore Private Industrial Estate,", "Kurichi, Coimbatore - Tamilnadu - 641 021."],
      location: "Coimbatore, Tamilnadu",
    },
    {
      name: "M/s. Farida Shoes Pvt. Ltd.",
      address: ["No.1, Vaniyambadi - Gudiyattam Rd,", "Thutipet, Ambur, Tamilnadu - 635 754."],
      location: "Ambur, Tamilnadu",
    },
    {
      name: "M/s. KPM Processing Mill Pvt. Ltd.",
      address: [
        "S.F. No.254/3A, Karaipudur Village,",
        "Chinnakarai, Arulpuram Post,",
        "Tiruppur, Tamilnadu - 641 605.",
      ],
      location: "Tiruppur, Tamilnadu",
    },
    {
      name: "M/s. Marutham Stones",
      address: ["S.F. No.14, Chettithottam, Irugalur,", "Sellappampatti, Sankari, Salem - 637 103."],
      location: "Salem, Tamilnadu",
    },
    {
      name: "M/s. NAARGO Industries Pvt. Ltd.",
      address: [
        "No.2, Gem Garden, Athipalayam Junction",
        "Opp. Bharathi Petrol Bunk,",
        "Sathy Road, Ganapathy,",
        "Coimbatore - 641 006.",
      ],
      location: "Coimbatore, Tamilnadu",
    },
    {
      name: "M/s. Narayana Hrudalaya",
      address: [
        "Building No-1, Basant Health Centre, 119/A,",
        "18th Main Rd, Opp. Sector 3, Sector 3, HSR Layout,",
        "Bengaluru, Karnataka - 560 102.",
      ],
      location: "Bengaluru, Karnataka",
    },
    {
      name: "M/s. P K H Exports Private Limited",
      address: [
        "4th Floor, Office No #12,",
        "Cisons Complex, Door No #150/128,",
        "Montieth Road, Egmore, Chennai - 600 008.",
      ],
      location: "Chennai, Tamilnadu",
    },
    {
      name: "M/s. R.K. Industries - IV",
      address: ["A-7 & 8, T.V.K. Industrial Estate, Guindy,", "Chennai - 600 032."],
      location: "Chennai, Tamilnadu",
    },
    {
      name: "M/s. Quality Glue Factory",
      address: ["No.1, Kothur Village, Kothur Post,", "Omarabad Via, Vellore Dist,", "Ambur, Tamilnadu - 635 808."],
      location: "Ambur, Tamilnadu",
    },
    {
      name: "M/s. R.R. Esculents",
      address: ["No.11B, RR Esculents Building,", "Ram Nagar,", "Gobichettipalayam,", "Erode District, Tamilnadu - 638 452."],
      location: "Erode, Tamilnadu",
    },
    {
      name: "M/s. SARA Leather Industries",
      address: ["No.91, MBT Road, Ranipet."],
      location: "Ranipet, Tamilnadu",
    },
    {
      name: "M/s. Shanthi Feeds Private Limited",
      address: ["No.6/15, Main Road, Pappampatti, Ondipudur (via),", "Coimbatore, Tamilnadu - 641 016."],
      location: "Coimbatore, Tamilnadu",
    },
    {
      name: "M/s. Silver Spark Apparel Limited (Unit 4)",
      address: ["Chokkahalli, Karnataka - 562 114."],
      location: "Karnataka",
    },
    {
      name: "M/s. Sonia Organics",
      address: ["No.11/2, KIADB Industrial Area,", "Balagaranahalli, Attibele Hobli,", "Anekal Taluk, Karnataka - 562 107."],
      location: "Karnataka",
    },
    {
      name: "M/s. Supreme Overseas Exports India Pvt. Ltd.",
      address: [
        "No.11/1, 24th 'A' Cross, Krishna Rajendra Road,",
        "Banashankari Stage II, Bengaluru - 560 070.",
      ],
      location: "Bengaluru, Karnataka",
    },
    {
      name: "M/s. Yield Engineering Services (P) Ltd.",
      address: [
        "No.96/3, S.F. No.253, Vadakku Sambala Thottam,",
        "Trichy Road, Kannampalayam,",
        "Sulur Taluk, Coimbatore - 641 402.",
      ],
      location: "Coimbatore, Tamilnadu",
    },
  ];

  return (
    <div style={{ background: "linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%)" }}>
      <Header />
      {/* Hero Header */}
      <div className="container-fluid bg-breadcrumb position-relative overflow-hidden">
        <div className="container text-center py-5" style={{ maxWidth: "900px", position: "relative", zIndex: 1 }}>
          <div className="mb-4">
            <div
              className="mx-auto mb-4"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              }}
            >
              <i className="fas fa-user-tie text-white" style={{ fontSize: "60px" }}></i>
            </div>
          </div>
          <h1 className="text-white display-4 mb-3 wow fadeInDown" data-wow-delay="0.1s" style={{ fontWeight: "700" }}>
            Vijayan Gokul
          </h1>
          <h4 className="text-white mb-4 wow fadeInDown" data-wow-delay="0.2s" style={{ opacity: 0.9 }}>
            Superintendent of Customs (Retired)
          </h4>
          <p className="text-white mb-4 font-size-p wow fadeInDown" data-wow-delay="0.3s" style={{ opacity: 0.85, maxWidth: "700px", margin: "0 auto" }}>
            Expert Consultant in Customs Matters, Electronic Sealing, Warehouse Licensing & Authorised Economic Operator Schemes
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap wow fadeInUp" data-wow-delay="0.4s">
            <a
              href="tel:+919597473746"
              className="btn btn-light btn-lg rounded-pill px-4"
              style={{ transition: "all 0.3s" }}
              onMouseEnter={(e) => (e.target.style.transform = "translateY(-2px)")}
              onMouseLeave={(e) => (e.target.style.transform = "translateY(0)")}
            >
              <i className="fas fa-phone me-2"></i> Call Now
            </a>
            <a
              href="mailto:vijayangokulg@gmail.com"
              className="btn btn-outline-light btn-lg rounded-pill px-4"
              style={{ transition: "all 0.3s" }}
              onMouseEnter={(e) => (e.target.style.transform = "translateY(-2px)")}
              onMouseLeave={(e) => (e.target.style.transform = "translateY(0)")}
            >
              <i className="fas fa-envelope me-2"></i> Email
            </a>
          </div>
          <ol className="breadcrumb d-flex justify-content-center mb-0 mt-4 wow fadeInDown" data-wow-delay="0.5s">
            <li className="breadcrumb-item">
              <Link to={"/"} className="text-white">Home</Link>
            </li>
            <li className="breadcrumb-item active text-white">Consultant</li>
          </ol>
        </div>
      </div>

      {/* Quick Stats Section */}
      <div className="container-fluid py-5" style={{ background: "#fff", marginTop: "-50px", position: "relative", zIndex: 2 }}>
        <div className="container">
          <div className="row g-4">
            <div className="col-md-3 col-sm-6">
              <div
                className="text-center p-4 rounded shadow-sm h-100"
                style={{
                  background: "linear-gradient(135deg, #2CAD51 0%, #3ed669 100%)",
                  color: "#fff",
                  transition: "transform 0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
              >
                <div className="mb-3">
                  <i className="fas fa-calendar-check" style={{ fontSize: "40px" }}></i>
                </div>
                <h3 className="mb-1" style={{ fontSize: "36px", fontWeight: "700" }}>
                  37+
                </h3>
                <p className="mb-0 font-size-p">Years of Experience</p>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div
                className="text-center p-4 rounded shadow-sm h-100"
                style={{
                  background: "linear-gradient(135deg, #2558A7 0%, #3971c5 100%)",
                  color: "#fff",
                  transition: "transform 0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
              >
                <div className="mb-3">
                  <i className="fas fa-graduation-cap" style={{ fontSize: "40px" }}></i>
                </div>
                <h3 className="mb-1" style={{ fontSize: "36px", fontWeight: "700" }}>
                  50+
                </h3>
                <p className="mb-0 font-size-p">Knowledge Areas</p>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div
                className="text-center p-4 rounded shadow-sm h-100"
                style={{
                  background: "linear-gradient(135deg, #EF3E2D 0%, #e65b4e 100%)",
                  color: "#fff",
                  transition: "transform 0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
              >
                <div className="mb-3">
                  <i className="fas fa-chalkboard-teacher" style={{ fontSize: "40px" }}></i>
                </div>
                <h3 className="mb-1" style={{ fontSize: "36px", fontWeight: "700" }}>
                  16+
                </h3>
                <p className="mb-0 font-size-p">Work Locations</p>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div
                className="text-center p-4 rounded shadow-sm h-100"
                style={{
                  background: "linear-gradient(135deg, #F9BC15 0%, #ffd768 100%)",
                  color: "#fff",
                  transition: "transform 0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
              >
                <div className="mb-3">
                  <i className="fas fa-language" style={{ fontSize: "40px" }}></i>
                </div>
                <h3 className="mb-1" style={{ fontSize: "36px", fontWeight: "700" }}>
                  6
                </h3>
                <p className="mb-0 font-size-p">Languages</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-fluid py-5" style={{ position: "relative", zIndex: 1 }}>
        <div className="container py-5" style={{ marginBottom: "50px" }}>
          {/* Tabs Navigation */}
          <div className="row mb-5">
            <div className="col-12">
              <div className="bg-white rounded shadow-sm p-2" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                <button
                  className={`btn flex-fill ${activeTab === "overview" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setActiveTab("overview")}
                  style={{ borderRadius: "10px", fontWeight: "600" }}
                >
                  <i className="fas fa-user me-2"></i> Overview
                </button>
                <button
                  className={`btn flex-fill ${activeTab === "knowledge" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setActiveTab("knowledge")}
                  style={{ borderRadius: "10px", fontWeight: "600" }}
                >
                  <i className="fas fa-brain me-2"></i> Knowledge
                </button>
                <button
                  className={`btn flex-fill ${activeTab === "experience" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setActiveTab("experience")}
                  style={{ borderRadius: "10px", fontWeight: "600" }}
                >
                  <i className="fas fa-briefcase me-2"></i> Experience
                </button>
                <button
                  className={`btn flex-fill ${activeTab === "services" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setActiveTab("services")}
                  style={{ borderRadius: "10px", fontWeight: "600" }}
                >
                  <i className="fas fa-handshake me-2"></i> Services
                </button>
                <button
                  className={`btn flex-fill ${activeTab === "clients" ? "btn-primary" : "btn-outline-primary"}`}
                  onClick={() => setActiveTab("clients")}
                  style={{ borderRadius: "10px", fontWeight: "600" }}
                >
                  <i className="fas fa-building me-2"></i> Clients
                </button>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === "overview" && (
            <div className="row g-4">
              {/* Personal Info Card */}
              <div className="col-lg-6">
                {/* <div
                  className="bg-white p-5 rounded shadow-sm h-100"
                  style={{
                    borderTop: "4px solid #667eea",
                    transition: "all 0.3s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.1)";
                  }}
                >
                  <h3 className="text-primary mb-4">
                    <i className="fas fa-info-circle me-2"></i>Personal Information
                  </h3>
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="d-flex align-items-start mb-3">
                        <div
                          className="me-3"
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "10px",
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                          }}
                        >
                          <i className="fas fa-birthday-cake"></i>
                        </div>
                        <div>
                          <strong className="d-block mb-1">Age</strong>
                          <span className="text-muted font-size-p">65 years</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start mb-3">
                        <div
                          className="me-3"
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "10px",
                            background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                          }}
                        >
                          <i className="fas fa-calendar-alt"></i>
                        </div>
                        <div>
                          <strong className="d-block mb-1">Service Period</strong>
                          <span className="text-muted font-size-p">21-12-1983 to 31/01/2021</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start mb-3">
                        <div
                          className="me-3"
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "10px",
                            background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                          }}
                        >
                          <i className="fas fa-map-marker-alt"></i>
                        </div>
                        <div>
                          <strong className="d-block mb-1">Residence</strong>
                          <span className="text-muted font-size-p">
                            No.36, Sobha Verdure, Harishree Gardens,<br />
                            Thondamuthur Road, Vedapatti,<br />
                            Coimbatore- 641 007
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-start mb-3">
                        <div
                          className="me-3"
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "10px",
                            background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                          }}
                        >
                          <i className="fas fa-phone"></i>
                        </div>
                        <div>
                          <strong className="d-block mb-1">Contact</strong>
                          <a href="tel:+919597473746" className="text-primary text-decoration-none font-size-p">
                            +91 9597473746
                          </a>
                          <br />
                          <a href="mailto:vijayangokulg@gmail.com" className="text-primary text-decoration-none font-size-p">
                            vijayangokulg@gmail.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                 <div
                  className="bg-white p-5 rounded shadow-sm"
                  style={{
                    borderTop: "4px solid #43e97b",
                    transition: "all 0.3s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.1)";
                  }}
                >
                  <h3 className="text-primary mb-3">
                    <i className="fas fa-building me-2"></i>Current Role
                  </h3>
                  <p className="font-size-p mb-2">
                    <strong>Director</strong> - EPIC-X Bharat Private Limited (IT Company), Coimbatore
                  </p>
                  <p className="font-size-p text-muted mb-0">
                    Practising as Consultant on Customs Matters, Electronic Sealing of Containers, Customs Special & Private Warehouse Licence, Authorised Economic Operator Scheme.
                  </p>
                </div>
              </div>

              {/* Languages & Current Role */}
              <div className="col-lg-6">
                <div
                  className="bg-white p-5 rounded shadow-sm mb-4"
                  style={{
                    borderTop: "4px solid #f5576c",
                    transition: "all 0.3s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.1)";
                  }}
                >
                  <h3 className="text-primary mb-4">
                    <i className="fas fa-language me-2"></i>Languages Known
                  </h3>
                  <div className="d-flex flex-wrap gap-2">
                    {["Hindi", "English", "Tamil", "Malayalam", "Sanskrit", "Kannada"].map((lang, idx) => (
                      <span
                        key={idx}
                        className="badge p-3 font-size-p"
                        style={{
                          background: `linear-gradient(135deg, ${["#2558A7", "#2CAD51", "#EF3E2D", "#F9BC15", "#2558A7", "#2CAD51"][idx]} 0%, ${["#2558A7", "#2CAD51", "#EF3E2D", "#F9BC15", "#2558A7", "#2CAD51"][idx]} 100%)`,
                          color: "#fff",
                          fontSize: "14px",
                          borderRadius: "8px",
                        }}
                      >
                        {lang}
                      </span>
                    ))}
                  </div>
                </div>

               
              </div>
            </div>
          )}

          {activeTab === "knowledge" && (
            <div className="row">
              <div className="col-12">
                <div
                  className="bg-white p-5 rounded shadow-sm"
                  style={{
                    borderTop: "4px solid #667eea",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="text-primary mb-0">
                      <i className="fas fa-brain me-2"></i>Knowledge Areas
                    </h3>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => toggleSection("knowledge")}
                    >
                      {expandedSections.knowledge ? "Show Less" : "Show All"}
                    </button>
                  </div>
                  <div className="row g-3">
                    {knowledgeAreas.slice(0, expandedSections.knowledge ? knowledgeAreas.length : 12).map((area, idx) => (
                      <div key={idx} className="col-md-6">
                        <div
                          className="p-3 rounded"
                          style={{
                            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                            borderLeft: "4px solid #667eea",
                            transition: "all 0.3s",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "linear-gradient(135deg, #2558A7 0%, #3280f5 100%)";
                            e.currentTarget.style.color = "#fff";
                            e.currentTarget.style.transform = "translateX(5px)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)";
                            e.currentTarget.style.color = "";
                            e.currentTarget.style.transform = "translateX(0)";
                          }}
                        >
                          <i className="fas fa-check-circle me-2 text-primary"></i>
                          <span className="font-size-p">{area}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  {!expandedSections.knowledge && (
                    <div className="text-center mt-4">
                      <button
                        className="btn btn-primary"
                        onClick={() => toggleSection("knowledge")}
                      >
                        View All {knowledgeAreas.length} Knowledge Areas
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === "experience" && (
            <div className="row g-4">
              {/* Industry Experience */}
              <div className="col-lg-6">
                <div
                  className="bg-white p-5 rounded shadow-sm"
                  style={{
                    borderTop: "4px solid #2558A7",
                  }}
                >
                  <h3 className="text-primary mb-4">
                    <i className="fas fa-industry me-2"></i>Industry Experience
                  </h3>
                  <div className="row g-3">
                    {[
                      { title: "Textile Machineries/Compressors & Electrical Machineries", chapter: "Chapter 84", locations: "Madurai, Coimbatore, Tiruppur, Cuddalore, Trichy" },
                      { title: "Textile Garments and Fabrics", chapter: "Chapter 61", locations: "Tiruppur, Coimbatore" },
                      { title: "Leather and Articles of Leather", chapter: "Chapter 64", locations: "CFS Ambur" },
                      { title: "Gelatin Glue made out of Animal Hides", chapter: "Chapter 33", locations: "CFS Ambur" },
                      { title: "Made-ups", chapter: "Chapter 65", locations: "ICD Karur" },
                      { title: "Drawback & IGST Refunds", chapter: "Zero Rated Supplies", locations: "Export Operations" },
                    ].map((item, idx) => (
                      <div key={idx} className="col-12">
                        <div
                          className="p-4 rounded"
                          style={{
                            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
                            border: "1px solid #e9ecef",
                            transition: "all 0.3s",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.borderColor = "#2558A7";
                            e.currentTarget.style.boxShadow = "0 5px 15px rgba(79, 172, 254, 0.2)";
                            e.currentTarget.style.transform = "translateY(-3px)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.borderColor = "#e9ecef";
                            e.currentTarget.style.boxShadow = "none";
                            e.currentTarget.style.transform = "translateY(0)";
                          }}
                        >
                          <h5 className="text-secondary mb-2">{item.title}</h5>
                          <p className="mb-1">
                            <strong className="text-primary">{item.chapter}</strong>
                          </p>
                          <p className="text-muted font-size-p mb-0">
                            <i className="fas fa-map-marker-alt me-1"></i>
                            {item.locations}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Work Experience */}
              <div className="col-lg-6">
                <div
                  className="bg-white p-5 rounded shadow-sm mb-4"
                  style={{
                    borderTop: "4px solid #f5576c",
                  }}
                >
                  <h3 className="text-primary mb-4">
                    <i className="fas fa-briefcase me-2"></i>Work Experience
                  </h3>
                  <div
                    className="p-3 rounded"
                    style={{
                      background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  >
                    {[
                      "Recognition & Registration of In-house R & D units under the Department of Scientific and Industrial Research",
                      "Training and Seminars on Indirect Taxation",
                      "Customs Circle, Tuticorin",
                      "Customs, Central Excise & Service Tax, Madurai",
                      "Central Excise & Service Tax, Chennai",
                      "Air Cargo Complex, Coimbatore",
                      "Container Freight Station, Thirumuruganpoondi",
                      "Customs Internal Audit, Tiruppur",
                      "International Airport, Coimbatore",
                      "Internal Audit Department, Customs, Central Excise & Service Tax, Coimbatore",
                      "Headquarters Preventive Unit, Customs, Central Excise & Service Tax, Coimbatore",
                      "Inland Container Depot",
                      "Divisional Preventive Unit, Cuddalore",
                      "Customs Policy Section, Customs(Preventive), Trichy",
                      "Container Freight Station, Ambur & Arakkonam",
                      "Inland Container Depot, Karur",
                      "Customs Preventive Unit, Coimbatore",
                    ].map((work, idx) => (
                      <div
                        key={idx}
                        className="d-flex align-items-center mb-3 p-2 rounded"
                        style={{
                          transition: "all 0.3s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "linear-gradient(135deg, #2558A7 0%, #3280f5 100%)";
                          e.currentTarget.style.color = "#fff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                          e.currentTarget.style.color = "";
                        }}
                      >
                        <i className="fas fa-building text-primary me-3"></i>
                        <span className="font-size-p">{work}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Training Experience */}
                <div
                  className="bg-white p-5 rounded shadow-sm"
                  style={{
                    borderTop: "4px solid #43e97b",
                  }}
                >
                  <h3 className="text-primary mb-4">
                    <i className="fas fa-graduation-cap me-2"></i>Training Experience
                  </h3>
                  <div className="row g-3">
                    {[
                      "Trainer of Trainer in Thematic Audit (NACEN)",
                      "Training for Examiners/Appraisers/Inspectors at NACIN Cochin",
                      "Training through FIEO (Min of Commerce)",
                      "Trainer in Central Excise Act & Rules",
                      "Trainer in Customs Act, 1962 & Rules",
                      "Trainer in Hazardous Substances & E-Waste Rules",
                    ].map((training, idx) => (
                      <div key={idx} className="col-12">
                        <div
                          className="p-3 rounded"
                          style={{
                            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                            borderLeft: "4px solid #43e97b",
                          }}
                        >
                          <i className="fas fa-chalkboard-teacher text-primary me-2"></i>
                          <span className="font-size-p">{training}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "services" && (
            <div className="row g-4">
              {[
                {
                  title: "Customs Disputes",
                  description: "Consultancy on disputes in Customs Matters",
                  icon: "fa-gavel",
                  color: "#2558A7",
                },
                {
                  title: "GST Disputes",
                  description: "Consultancy on disputes arising in GST Matters",
                  icon: "fa-file-invoice-dollar",
                  color: "#EF3E2D",
                },
                {
                  title: "Electronic Sealing",
                  description: "Consultancy on Electronic Sealing of Containers",
                  icon: "fa-lock",
                  color: "#F9BC15",
                },
                {
                  title: "Reefer Containers",
                  description: "Consultancy on Electronic Sealing of Reefer Containers",
                  icon: "fa-snowflake",
                  color: "#2CAD51",
                },
                {
                  title: "Customs Warehouse",
                  description: "Consultancy on establishing Customs Licensed Special/Private Warehouse (MOOWR)",
                  icon: "fa-warehouse",
                  color: "#2558A7",
                },
                {
                  title: "Authorised Economic Operator",
                  description: "Consultancy for AEO-T1, T2, T2 Renewal, T-3 & LO levels",
                  icon: "fa-user-shield",
                  color: "#EF3E2D",
                },
                {
                  title: "R & D Units",
                  description: "Recognition & Registration of In-house R & D units for Income Tax and Customs benefits",
                  icon: "fa-flask",
                  color: "#F9BC15",
                },
                {
                  title: "Training Services",
                  description: "Training on Customs Act, 1962, Allied Acts, Import and Export Procedures",
                  icon: "fa-chalkboard-teacher",
                  color: "#2CAD51",
                },
                {
                  title: "Specialized Training",
                  description: "Training on Hazardous Substances, Ozone Depleting Substances & e-Waste Rules",
                  icon: "fa-exclamation-triangle",
                  color: "#2558A7",
                },
                {
                  title: "Post Clearance Audit",
                  description: "Training on On-Site Post Clearance Audit (OSPCA) for Accredited Clients Programme & AEO",
                  icon: "fa-clipboard-check",
                  color: "#EF3E2D",
                },
                {
                  title: "CETA Training",
                  description: "Training on United Kingdom-India Comprehensive Economic & Trade Agreement (CETA)",
                  icon: "fa-handshake",
                  color: "#F9BC15",
                },
              ].map((service, idx) => (
                <div key={idx} className="col-lg-4 col-md-6">
                  <div
                    className="bg-white p-4 rounded shadow-sm h-100"
                    style={{
                      borderTop: `4px solid ${service.color}`,
                      transition: "all 0.3s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-8px)";
                      e.currentTarget.style.boxShadow = `0 15px 35px ${service.color}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.1)";
                    }}
                  >
                    <div
                      className="mb-3 d-inline-flex align-items-center justify-content-center rounded"
                      style={{
                        width: "60px",
                        height: "60px",
                        background: `linear-gradient(135deg, ${service.color} 0%, ${service.color}dd 100%)`,
                        color: "#fff",
                      }}
                    >
                      <i className={`fas ${service.icon}`} style={{ fontSize: "24px" }}></i>
                    </div>
                    <h5 className="text-secondary mb-2">{service.title}</h5>
                    <p className="font-size-p text-muted mb-0">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          )}

          {activeTab === "clients" && (
            <div className="row">
              <div className="col-12">
                <div
                  className="bg-white p-5 rounded shadow-sm"
                  style={{
                    borderTop: "4px solid #2558A7",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                    <div>
                      <h3 className="text-primary mb-1">
                        <i className="fas fa-handshake me-2"></i>Our Clients
                      </h3>
                      <p className="text-muted font-size-p mb-0">A few of the organizations supported through consultancy and advisory.</p>
                    </div>
                    <button className="btn btn-sm btn-outline-primary" onClick={() => toggleSection("clients")}>
                      {expandedSections.clients ? "Show Less" : "Show All"}
                    </button>
                  </div>

                  <div className="row g-4">
                    {clients.slice(0, expandedSections.clients ? clients.length : 9).map((client, idx) => (
                      <div key={`${client.name}-${idx}`} className="col-lg-4 col-md-6">
                        <div
                          className="p-4 rounded h-100"
                          style={{
                            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
                            border: "1px solid #e9ecef",
                            borderTop: "4px solid #2558A7",
                            transition: "all 0.3s",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "translateY(-6px)";
                            e.currentTarget.style.boxShadow = "0 15px 35px rgba(118, 75, 162, 0.18)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        >
                          <div className="d-flex align-items-start gap-3">
                            <div
                              className="d-inline-flex align-items-center justify-content-center rounded"
                              style={{
                                width: "48px",
                                height: "48px",
                                flex: "0 0 48px",
                                background: "linear-gradient(135deg, #2558A7 0%, #3280f5 100%)",
                                color: "#fff",
                              }}
                            >
                              <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div>
                              <h6 className="mb-2" style={{ fontWeight: 700, color: "#2c3e50" }}>
                                {client.name}
                              </h6>
                              <div className="text-muted font-size-p" style={{ lineHeight: 1.6 }}>
                                {client.address.map((line, lineIdx) => (
                                  <div key={lineIdx}>{line}</div>
                                ))}
                              </div>
                              <div className="mt-3">
                                <span
                                  className="badge"
                                  style={{
                                    background: "linear-gradient(135deg, #2558A7 0%, #3280f5 100%)",
                                    color: "#fff",
                                    padding: "8px 10px",
                                    borderRadius: "10px",
                                    fontSize: "12px",
                                  }}
                                >
                                  <i className="fas fa-location-arrow me-2"></i>
                                  {client.location}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {!expandedSections.clients && clients.length > 9 && (
                    <div className="text-center mt-4">
                      <button className="btn btn-primary" onClick={() => toggleSection("clients")}>
                        View All {clients.length} Clients
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Contact CTA Section */}
      <div className="container-fluid py-5" style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", position: "relative", zIndex: 2 }}>
        <div className="container text-center py-5">
          <h2 className="text-white mb-4">Ready to Get Started?</h2>
          <p className="text-white mb-4 font-size-p" style={{ opacity: 0.9, maxWidth: "600px", margin: "0 auto" }}>
            Contact us today for expert consultancy services in Customs, GST, and International Trade matters.
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a
              href="tel:+919597473746"
              className="btn btn-light btn-lg rounded-pill px-5"
              style={{ transition: "all 0.3s" }}
              onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
            >
              <i className="fas fa-phone me-2"></i> Call Now
            </a>
            <a
              href="mailto:vijayangokulg@gmail.com"
              className="btn btn-outline-light btn-lg rounded-pill px-5"
              style={{ transition: "all 0.3s" }}
              onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
            >
              <i className="fas fa-envelope me-2"></i> Send Email
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ConsultantProfile;
